import { ObjectInspector } from "react-inspector";
import { Button, Popup } from "semantic-ui-react";

export function FieldRawPopup({row}) {
	return (
		<Popup
			trigger={<Button icon="add"/>}
			position="left center"
			on="click"
			style={{
				height: '80%',
				width: '80%',
				minWidth: 700,
				overflow: 'scroll',
			}}
		>
			<ObjectInspector data={row} expandLevel={2}/>
		</Popup>

	);
}
